import React from "react";
import Box from "react-raster";
import { Link } from "gatsby";
import styled from "styled-components";
import Container from "../Container";
import { H2, Eyebrow } from "../Typography";
import Arrow, { ArrowContainer, arrowHoverStyles } from "../Arrow";

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.colours.grey};
  text-transform: uppercase;
  font-size: 18px;
  display: flex;
  align-items: center;
  margin-top: 60px;
  ${arrowHoverStyles};
`;

// use order to support arrowHoverStyles, which expects first div
// to be an arrow container
const Label = styled.strong`
  margin-right: 16px;
  order: 1;
`;

const StyledArrowContainer = styled(ArrowContainer)`
  order: 2;
`;

const FullWidthWrapper = styled.div`
  background-color: ${({ theme, $backgroundColour }) =>
    theme.colours[$backgroundColour]};
  width: 100%;
  padding-bottom: ${({ $hasBottomMargin }) =>
    $hasBottomMargin ? "60px" : "20px"};
  padding-top: ${({ $hasTopMargin }) => ($hasTopMargin ? "60px" : "20px")};
`;

function EyebrowAndTitle({
  eyebrow,
  title,
  alignment,
  ctaUrl,
  ctaLabel,
  isSticky,
  hideTitle,
  hasBottomMargin,
  backgroundColour,
  hasTopMargin,
}) {
  const left = {
    left: 0,
    centre: 3,
    right: 6,
  };

  return (
    <FullWidthWrapper
      $backgroundColour={backgroundColour}
      $hasBottomMargin={hasBottomMargin}
      $hasTopMargin={hasTopMargin}
    >
      <Container
        style={
          isSticky && {
            position: "sticky",
            top: 0,
          }
        }
      >
        <Box
          marginTop={1}
          cols={[6, 12, 8]}
          marginBottom={isSticky ? [8, 8, 5] : 2}
          marginLeft={[0, 0, left[alignment] || 0]}
        >
          {eyebrow && <Eyebrow colour="blue">{eyebrow}</Eyebrow>}
          {title && !hideTitle && <H2>{title}</H2>}
          {ctaLabel && ctaUrl && (
            <StyledLink to={ctaUrl}>
              <StyledArrowContainer large>
                <Arrow large colour="white" transform="rotate(-90deg)" />
              </StyledArrowContainer>
              <Label>{ctaLabel}</Label>
            </StyledLink>
          )}
        </Box>
      </Container>
    </FullWidthWrapper>
  );
}

export default EyebrowAndTitle;
